import { ApplicationState } from '../../../../store/types';
import { getAIRoot } from '../../store/selectors';

export const getAIQueriesRoot = (state: ApplicationState) => getAIRoot(state).queries;
export const getAIChatbotRoot = (state: ApplicationState) => getAIRoot(state).chatbot;
export const getAIPlaygroundRoot = (state: ApplicationState) => getAIRoot(state).playground;
export const getFewShotDocumentsRoot = (state: ApplicationState) => getAIRoot(state).fewShotDocuments;
